import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
const PartnerFinderFade = require('../../../../www/images/partner-finder-fade.png');

const FindNewPartners = props => {
  const { history } = props;
  const goToPartnerFinder = () => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: 'TRACK_EVENT',
        ev: {
          category: 'PartnerFinder',
          action: 'Clicks from Connections',
        },
      });
    }
    history.push('/partner-finder/results');
  };
  return (
    <div>
      <div
        className="connections-left-nav-heading"
        style={{ cursor: 'pointer' }}
        onClick={() => goToPartnerFinder()}
      >
        Partner Search
      </div>
      <div
        style={{ margin: '15px 15px 25px', cursor: 'pointer' }}
        onClick={() => goToPartnerFinder()}
      >
        <img src={PartnerFinderFade} />
      </div>
    </div>
  );
};

FindNewPartners.propTypes = {
  user: PropTypes.object,
  history: PropTypes.object,
};

const mapStateToProps = ({ user }) => ({
  user: user.toJS(),
});

export default connect(mapStateToProps)(FindNewPartners);



// WEBPACK FOOTER //
// ./src/app/components/connections/connections-left-nav/find-new-partners.jsx